import { FC, useRef, useCallback } from 'react';

// material-ui
import { Badge, Box } from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

// assets
import useNotifications from '../../../../hooks/useNotifications';
import CommonHeaderBtn from '../../../../ui-component/CommonHeaderBtn';
import NotificationPreview from './NotificationPreview';
import useNotificationsListener from '../../../../hooks/useNotificationsListener';
import { useAppDispatch } from '../../../../hooks/redux';
import { DialogTypes, openDialog } from '../../../../store/slices/entityDialogsSlice';

// ==============================|| NOTIFICATION ||============================== //

const NotificationSection: FC = () => {
    const dispatch = useAppDispatch();

    const onOpenNotificationsList = useCallback(() => {
        dispatch(openDialog({ type: DialogTypes.Notifications, id: null }));
    }, [dispatch]);

    /**
     * anchorRef is used on different components and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef<any>(null);

    const { unreadNotificationsLength } = useNotifications();
    const { current, dismissNotification } = useNotificationsListener();

    return (
        <Box sx={{ display: 'flex' }} component="span" ref={anchorRef}>
            <CommonHeaderBtn onClick={onOpenNotificationsList}>
                <Badge
                    color="error"
                    overlap="circular"
                    variant="dot"
                    invisible={!unreadNotificationsLength}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <NotificationsOutlinedIcon />
                </Badge>
            </CommonHeaderBtn>
            {/* Notifications Preview */}
            <Box sx={{ position: 'relative' }}>
                {!!current && (
                    <Box sx={{ position: 'absolute', width: '500px', right: 0, top: 0, bottom: 0, zIndex: 2 }}>
                        {current && <NotificationPreview notification={current} onDismiss={dismissNotification} />}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default NotificationSection;
